<template>
  <pagefra>
    <div
      class="serviceFeedback container"
      v-loading.fullscreen.lock="fullLoading"
      element-loading-background="rgba(0, 0, 0, 0.1)"
    >
      <panel type="toolbar">
        <div class="toolbar">
          <el-form class="toolbar-form" :inline="true" v-model="form">
            <el-form-item :label="$l('状态')">
              <el-select v-model="form.status" :placeholder="$l('请选择状态')">
                <el-option :label="$l('状态')" value></el-option>
                <el-option :label="$l('处理中')" value="1"></el-option>
                <el-option :label="$l('已回复')" value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$l('关键字')">
              <el-input
                v-model="form.keyword"
                :placeholder="$l('关键字')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('提交时间')">
              <el-date-picker
                v-model="timeValues"
                type="daterange"
                :range-separator="$l('至')"
                :start-placeholder="$l('开始时间')"
                :end-placeholder="$l('结束时间')"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button
                icon="el-icon-search"
                type="primary"
                circle
                @click="search"
              ></el-button>
            </el-form-item>
          </el-form>
          <div class="toolbar-btn">
            <el-button
              type="primary"
              round
              @click="openFeedDialog"
              v-if="hasPermission('反馈')"
              >{{ $l("反馈") }}
            </el-button>
          </div>
        </div>
      </panel>
      <el-dialog
        :visible.sync="feedVisible"
        :title="$l('服务问题反馈')"
        width="640px"
        :close-on-click-modal="false"
        custom-class="feed-dialog-box"
        @closed="resetFeedDialog"
      >
        <el-form
          ref="feedForm"
          :model="feedForm"
          :rules="feedRules"
          label-width="110px"
          size="medium"
        >
          <el-form-item :label="$l('填单人姓名')" prop="linkName">
            <el-input
              v-model="feedForm.linkName"
              :placeholder="$l('请输入填单人姓名')"
              maxlength="50"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$l('联系电话')" prop="linkPhone">
            <el-input
              v-model="feedForm.linkPhone"
              :placeholder="$l('请输入联系电话')"
              maxlength="11"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$l('分公司')" prop="officeCode">
            <el-select
              v-model="feedForm.officeCode"
              :placeholder="$l('请选择分公司')"
              clearable
              style="width: 100%"
            >
              <el-option
                v-for="item in companyOptions"
                :key="item.companyCode"
                :label="item.companyName"
                :value="item.companyCode"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$l('电梯工号')" prop="liftNo">
            <el-select
              v-model="feedForm.liftNo"
              filterable
              remote
              reserve-keyword
              :remote-method="searchElevator"
              :loading="elevatorLoading"
              :placeholder="$l('请输入电梯工号搜索')"
              popper-class="feed-elevator-dropdown"
              style="width: 100%"
              @change="onElevatorChange"
            >
              <el-option
                v-for="item in elevatorOptions"
                :key="item.jobNum"
                :label="item.jobNum"
                :value="item.jobNum"
              >
                <div class="feed-elevator-option">
                  <div class="feed-elevator-option__job">{{ item.jobNum }}</div>
                  <div class="feed-elevator-option__addr">
                    {{ item.address }}
                  </div>
                </div>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$l('项目名称')" prop="projectName">
            <el-input
              v-model="feedForm.projectName"
              :placeholder="$l('请输入项目名称')"
              maxlength="100"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$l('主题')" prop="subject">
            <el-input
              v-model="feedForm.subject"
              :placeholder="$l('请输入主题')"
              maxlength="100"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$l('具体内容')" prop="description">
            <el-input
              v-model="feedForm.description"
              type="textarea"
              :rows="3"
              :placeholder="$l('请输入具体内容')"
              @input="descriptionInput"
            ></el-input>
            <div class="desc-count">{{ descriptionCount }}/500</div>
          </el-form-item>
          <el-form-item :label="$l('上传图片')" prop="imgs">
            <el-upload
              ref="feedUpload"
              multiple
              :limit="3"
              action=""
              accept="image/*"
              :http-request="handleUpload"
              :on-remove="onUploadRemove"
              :on-exceed="onUploadExceed"
            >
              <el-button size="small" type="primary">{{$l('选择图片')}}</el-button>
              <div slot="tip" class="el-upload__tip">{{$l('最多上传3张图片')}}</div>
            </el-upload>
          </el-form-item>
        </el-form>
        <div slot="footer" class="feed-dialog__footer">
          <el-button @click="feedVisible = false">{{$l('取 消')}}</el-button>
          <el-button
            type="primary"
            :disabled="uploading > 0"
            @click="submitFeed"
            >{{$l('提 交')}}</el-button
          >
        </div>
      </el-dialog>
      <el-dialog
        :visible.sync="replyVisible"
        :title="$l('问题反馈详情')"
        width="640px"
        :close-on-click-modal="false"
        custom-class="feed-reply-dialog"
      >
        <div v-loading.lock="detailLoading" class="feed-reply-dialog__body">
          <div class="feed-detail">
            <div class="feed-detail__title">{{ $l("反馈") }}</div>
            <div class="feed-detail__rows">
              <div class="feed-detail__row">
                <span class="label">{{ $l("填单人姓名") }}</span>
                <span class="value">{{ detail.linkName }}</span>
              </div>
              <div class="feed-detail__row">
                <span class="label">{{ $l("联系电话") }}</span>
                <span class="value">{{ detail.linkPhone }}</span>
              </div>
              <div class="feed-detail__row">
                <span class="label">{{ $l("分公司") }}</span>
                <span class="value">{{ officeName }}</span>
              </div>
              <div class="feed-detail__row">
                <span class="label">{{ $l("电梯工号") }}</span>
                <span class="value">{{ detail.liftNo }}</span>
              </div>
              <div class="feed-detail__row">
                <span class="label">{{ $l("项目名称") }}</span>
                <span class="value">{{ detail.projectName }}</span>
              </div>
              <div class="feed-detail__row">
                <span class="label">{{ $l("主题") }}</span>
                <span class="value">{{ detail.subject }}</span>
              </div>
              <div class="feed-detail__row">
                <span class="label">{{ $l("具体内容") }}</span>
                <span class="value feed-detail__desc">{{
                  detail.description
                }}</span>
              </div>
              <div class="feed-detail__row">
                <span class="label">{{ $l("上传图片") }}</span>
                <span class="value">
                  <div class="feed-detail__imgs">
                    <el-image
                      v-for="(img, i) in detailImgs"
                      :key="i"
                      class="feed-detail__img"
                      :src="img.url"
                      :preview-src-list="detailImgs.map((x) => x.url)"
                    ></el-image>
                    <span v-if="!detailImgs.length">-</span>
                  </div>
                </span>
              </div>
            </div>
          </div>
          <div class="feed-detail">
            <div class="feed-detail__title">{{ $l("回复") }}</div>
            <div class="feed-reply-list" v-if="replyList.length">
              <div
                v-for="(item, idx) in replyList"
                :key="idx"
                class="feed-reply-item"
              >
                <div class="feed-reply-item__avatar">
                  <i class="el-icon-user-solid"></i>
                </div>
                <div class="feed-reply-item__main">
                  <div class="feed-reply-item__head">
                    <span class="name">{{ item.replyName }}</span>
                    <span class="time">{{ item.createTime }}</span>
                  </div>
                  <div class="feed-reply-item__body">
                    <div class="feed-reply-item__content" v-if="item.content">
                      {{ item.content }}
                    </div>
                    <div
                      class="feed-reply-item__imgs"
                      v-if="item.replyImgs.length"
                    >
                      <el-image
                        v-for="(rimg, ri) in item.replyImgs"
                        :key="ri"
                        class="feed-reply-item__img"
                        :src="rimg.url"
                        :preview-src-list="item.replyImgs.map((x) => x.url)"
                        fit="cover"
                      ></el-image>
                    </div>
                    <span
                      v-if="!item.content && !item.replyImgs.length"
                      class="feed-reply-item__none"
                      >-</span
                    >
                  </div>
                </div>
              </div>
            </div>
            <p v-if="!replyList.length" class="feed-reply-empty">暂无回复</p>
          </div>
        </div>
        <div slot="footer" class="feed-dialog__footer">
          <el-button @click="replyVisible = false">关 闭</el-button>
        </div>
      </el-dialog>
      <panel class="panel-table">
        <div class="panel-table__table">
          <el-table
            ref="filterTable"
            size="medium"
            tooltip-effect="tableTooltip"
            highlight-current-row
            height="100%"
            v-loading.lock="loading"
            :data="tableData"
            style="width: 100%; z-index: 1000"
          >
            <el-table-column
              type="index"
              :label="$l('序号')"
              width="80"
              align="center"
            ></el-table-column>
            <el-table-column
              :label="$l('电梯工号')"
              prop="liftNo"
              align="center"
              width="130"
            ></el-table-column>
            <el-table-column
              :label="$l('项目名称')"
              prop="projectName"
              align="center"
              min-width="160"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              :label="$l('联系人姓名')"
              prop="linkName"
              align="center"
              width="110"
            ></el-table-column>
            <el-table-column
              :label="$l('联系电话')"
              prop="linkPhone"
              align="center"
              width="130"
            ></el-table-column>
            <el-table-column
              :label="$l('主题')"
              prop="subject"
              align="center"
              min-width="140"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              :label="$l('描述')"
              prop="description"
              align="center"
              min-width="200"
            >
              <template slot-scope="scope">
                <div class="feedback-description">
                  {{ scope.row.description }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              :label="$l('分公司编码')"
              prop="officeCode"
              align="center"
              width="120"
            ></el-table-column>
            <el-table-column :label="$l('状态')" align="center" width="100">
              <template slot-scope="scope">
                {{ scope.row.status == 1 ? $l("处理中") : $l("已回复") }}
              </template>
            </el-table-column>
            <el-table-column
              :label="$l('创建时间')"
              prop="createTime"
              align="center"
              width="170"
            ></el-table-column>
            <el-table-column
              :label="$l('详情')"
              align="center"
              width="80"
              fixed="right"
              v-if="hasPermission('详情')"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  icon="el-icon-document"
                  class="table-icon"
                  @click="openDetailDialog(scope.row)"
                ></el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          :current-page="pageConfig.currentPage"
          :page-sizes="pageConfig.pageSizes"
          :page-size="pageConfig.pageSize"
          :total="pageConfig.total"
          @size-change="handlePageSizeChange"
          @current-change="handleCurrentPageChange"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </panel>
    </div>
  </pagefra>
</template>

<script>
// @ is an alias to /src
import panel from "@/components/panel.vue";
import global from "@/mixins/global.js";
export default {
  name: "serviceFeedback",
  mixins: [global],
  components: {
    panel,
  },
  props: {
    loaded: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      timeValues: [],
      form: {
        status: "",
        keyword: "",
      },
      tableData: [],
      loading: false,
      fullLoading: false,
      feedVisible: false,
      replyVisible: false,
      replyLoading: false,
      replyList: [],
      detailLoading: false,
      detail: {},
      detailImgs: [],
      companyOptions: [],
      elevatorOptions: [],
      elevatorLoading: false,
      uploading: 0,
      uploadedImgs: [],
      feedForm: {
        linkName: "",
        linkPhone: "",
        officeCode: "",
        liftNo: "",
        projectName: "",
        subject: "",
        description: "",
        imgs: "",
      },
      feedRules: {
        linkName: [
          {
            required: true,
            message: this.$l("请输入填单人姓名"),
            trigger: "blur",
          },
        ],
        linkPhone: [
          {
            required: true,
            message: this.$l("请输入联系电话"),
            trigger: "blur",
          },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: this.$l("手机号格式不正确"),
            trigger: "blur",
          },
        ],
        officeCode: [
          {
            required: true,
            message: this.$l("请选择分公司"),
            trigger: "change",
          },
        ],
        liftNo: [
          {
            required: true,
            message: this.$l("请输入电梯工号"),
            trigger: "blur",
          },
        ],
        projectName: [
          {
            required: true,
            message: this.$l("请输入项目名称"),
            trigger: "blur",
          },
        ],
        subject: [
          { required: true, message: this.$l("请输入主题"), trigger: "blur" },
        ],
        description: [
          {
            required: true,
            message: this.$l("请输入具体内容"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    descriptionCount() {
      return (this.feedForm.description || "").replace(/(^\s*)|(\s*$)/g, "")
        .length;
    },
    officeName() {
      const matched = this.companyOptions.find(
        (item) => item.companyCode == this.detail.officeCode
      );
      return matched ? matched.companyName : this.detail.officeCode || "-";
    },
  },
  mounted() {
    if (this.loaded) {
      this.initData();
    }
  },
  methods: {
    search() {
      this.pageConfig.currentPage = 1;
      this.initData();
    },
    reset() {
      this.timeValues = [];
      this.form.status = "";
      this.form.keyword = "";
      this.pageConfig.currentPage = 1;
      this.initData();
    },
    initData() {
      const dataListCacheKey = this.$options.name + "_data_list";
      const dataTotalCacheKey = this.$options.name + "_data_total";
      if (this.$store.state.pageScroll.scroll) {
        const json = sessionStorage.getItem(dataListCacheKey);
        if (json) {
          this.tableData = JSON.parse(json);
          this.pageConfig.total = parseInt(
            sessionStorage.getItem(dataTotalCacheKey)
          );
          sessionStorage.removeItem(dataTotalCacheKey);
          sessionStorage.removeItem(dataListCacheKey);
          return;
        }
      }
      let params = {
        page: this.pageConfig.currentPage,
        limit: this.pageConfig.pageSize,
        status: this.form.status,
        keyword: this.form.keyword,
      };
      if (params.status === "" || params.status === undefined) {
        delete params.status;
      }
      if (params.keyword && !params.keyword.trim()) {
        delete params.keyword;
      }
      if (this.timeValues && this.timeValues.length == 2) {
        params.startCreateTime = this.timeValues[0];
        params.endCreateTime = this.timeValues[1];
      }
      this.tableData = [];
      this.loading = true;
      this.$http
        .post(this.$apiConfig.get_fd_problem_feedback_list_url, params)
        .then((response) => {
          this.loading = false;
          let result = response.data;
          if (result.code == 0) {
            const data = result.data || {};
            this.pageConfig.total = data.total || 0;
            this.tableData = data.records || [];
            if (
              !this.loaded &&
              this.$store.state.pageScroll.scroll &&
              !sessionStorage.getItem(dataListCacheKey)
            ) {
              sessionStorage.setItem(dataTotalCacheKey, this.pageConfig.total);
              sessionStorage.setItem(
                dataListCacheKey,
                JSON.stringify(this.tableData)
              );
            }
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
    openFeedDialog() {
      this.feedForm = {
        linkName: "",
        linkPhone:
          (this.$store.state.user && this.$store.state.user.telNum) || "",
        officeCode: "",
        liftNo: "",
        projectName: "",
        subject: "",
        description: "",
        imgs: "",
      };
      this.uploadedImgs = [];
      this.elevatorOptions = [];
      this.feedVisible = true;
      this.loadCompany();
      this.$nextTick(() => {
        this.$refs.feedForm && this.$refs.feedForm.clearValidate();
        this.searchElevator("");
      });
    },
    resetFeedDialog() {
      this.feedForm = {
        linkName: "",
        linkPhone: "",
        officeCode: "",
        liftNo: "",
        projectName: "",
        subject: "",
        description: "",
        imgs: "",
      };
      this.uploadedImgs = [];
      this.elevatorOptions = [];
      if (this.$refs.feedForm) {
        this.$refs.feedForm.resetFields();
      }
      if (this.$refs.feedUpload) {
        this.$refs.feedUpload.clearFiles();
      }
    },
    openDetailDialog(row) {
      this.detail = {};
      this.detailImgs = [];
      this.replyList = [];
      this.replyVisible = true;
      this.loadDetail(row);
    },
    loadDetail(row) {
      const ticketNo = (row && row.ticketNo) || "";
      this.detailLoading = true;
      this.$http
        .get(this.$apiConfig.get_fd_problem_feedback_detail_url, {
          params: { ticketNo },
        })
        .then((response) => {
          this.detailLoading = false;
          const result = response.data;
          if (result.code == 0) {
            this.detail = result.data || {};
            this.loadDetailImgs(this.detail.imgs);
            const replys = this.detail.replys || [];
            this.replyList = replys.map((item) => ({ ...item, replyImgs: [] }));
            this.loadReplyImgs(this.replyList);
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.detailLoading = false;
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
    loadReplyImgs(list) {
      (list || []).forEach((item) => {
        if (!item || !item.imgs) {
          return;
        }
        let arr = item.imgs;
        if (typeof item.imgs === "string") {
          try {
            arr = JSON.parse(item.imgs);
          } catch (e) {
            return;
          }
        }
        if (!Array.isArray(arr)) {
          return;
        }
        arr.forEach((img) => {
          if (img && img.id != null) {
            this.$http
              .get(this.$apiConfig.get_fd_download_url, {
                params: { fileId: img.id },
              })
              .then((res) => {
                const r = res.data;
                if (r.code == 0) {
                  item.replyImgs.push({ url: r.data && r.data.downloadUrl });
                }
              })
              .catch((error) => {
                this.$sentry.captureException(error);
              });
          }
        });
      });
    },
    loadDetailImgs(imgs) {
      this.detailImgs = [];
      if (!imgs) {
        return;
      }
      let arr = imgs;
      if (typeof imgs === "string") {
        try {
          arr = JSON.parse(imgs);
        } catch (e) {
          arr = [];
        }
      }
      if (!Array.isArray(arr)) {
        return;
      }
      arr.forEach((item) => {
        if (item && item.id != null) {
          this.$http
            .get(this.$apiConfig.get_fd_download_url, {
              params: { fileId: item.id },
            })
            .then((res) => {
              const r = res.data;
              if (r.code == 0) {
                this.detailImgs.push({ url: r.data && r.data.downloadUrl });
              }
            })
            .catch((error) => {
              this.detailLoading = false;
              this.errorMessage();
              this.$sentry.captureException(error);
            });
        }
      });
    },
    onElevatorChange(value) {
      const matched = this.elevatorOptions.find((item) => item.jobNum == value);
      if (matched && matched.address) {
        this.feedForm.projectName = matched.address;
      }
    },
    descriptionInput(val) {
      const meaningful = val.replace(/(^\s*)|(\s*$)/g, "").length;
      if (meaningful > 500) {
        this.feedForm.description = val
          .replace(/(^\s*)|(\s*$)/g, "")
          .slice(0, 500);
      }
    },
    searchElevator(query) {
      const kw = (query || "").trim();
      this.elevatorLoading = true;
      this.$http
        .get(this.$apiConfig.get_elevator_by_jobnum_url, {
          params: { jobNum: kw, elevatorType: "" },
        })
        .then((response) => {
          this.elevatorLoading = false;
          const result = response.data;
          if (result.code == 0) {
            this.elevatorOptions = (result.data || []).map((item) => ({
              jobNum: item.jobNum,
              address: item.address,
            }));
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.elevatorLoading = false;
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
    loadCompany() {
      this.$http
        .get(this.$apiConfig.get_fd_company_list_url)
        .then((response) => {
          const result = response.data;
          if (result.code == 0) {
            this.companyOptions = result.data || [];
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
    handleUpload(option) {
      this.uploading++;
      const uid = option.file.uid;
      const formData = new FormData();
      formData.append("file", option.file);
      this.$http
        .post(this.$apiConfig.upload_fd_problem_feedback_url, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          this.uploading--;
          const result = response.data;
          if (result.code == 0) {
            const info = result.data || {};
            this.uploadedImgs.push({
              uid,
              id: info.fileId,
              name: info.originName,
            });
            option.onSuccess && option.onSuccess(response);
          } else {
            this.message(result.code, result.msg);
            option.onError && option.onError(response);
          }
        })
        .catch((error) => {
          this.uploading--;
          option.onError && option.onError(error);
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
    onUploadRemove(file) {
      const idx = this.uploadedImgs.findIndex((x) => x.uid === file.uid);
      if (idx > -1) {
        this.uploadedImgs.splice(idx, 1);
      }
    },
    onUploadExceed() {
      this.$message.warning(this.$l("最多只能上传3个文件"));
    },
    submitFeed() {
      this.$refs.feedForm.validate((valid) => {
        if (!valid) {
          return;
        }
        const payload = { ...this.feedForm };
        if (this.uploadedImgs.length) {
          payload.imgs = JSON.stringify(
            this.uploadedImgs.map((x) => ({ id: x.id, name: x.name }))
          );
        }
        this.fullLoading = true;
        this.$http
          .post(this.$apiConfig.add_fd_problem_feedback_url, payload)
          .then((response) => {
            this.fullLoading = false;
            const result = response.data;
            this.message(result.code, result.msg);
            if (result.code == 0) {
              this.feedVisible = false;
              this.initData();
            }
          })
          .catch((error) => {
            this.fullLoading = false;
            this.errorMessage();
            this.$sentry.captureException(error);
          });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.serviceFeedback {
  .feedback-description {
    white-space: normal;
    line-height: 20px;
    padding: 5px 0;
  }
  .desc-count {
    margin-top: 4px;
    font-size: 12px;
    line-height: 1;
    color: #909399;
    text-align: right;
  }
  .feed-reply-dialog__body {
  }
  .feed-detail {
    margin-bottom: 8px;
    &__title {
      font-size: 14px;
      font-weight: 700;
      color: #303133;
      margin-bottom: 10px;
      padding-left: 8px;
      border-left: 3px solid #409eff;
    }
    &__desc {
      white-space: pre-line;
      word-break: break-word;
    }
    &__rows {
      border: 1px solid #ebeef5;
      border-radius: 4px;
    }
    &__row {
      display: flex;
      border-bottom: 1px solid #ebeef5;
      &:last-child {
        border-bottom: none;
      }
      .label {
        width: 110px;
        flex-shrink: 0;
        padding: 8px 12px;
        color: #909399;
        background: #f5f7fa;
        box-sizing: border-box;
      }
      .value {
        flex: 1;
        padding: 8px 12px;
        color: #606266;
        word-break: break-word;
      }
    }
    &__imgs {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
    }
    &__img {
      width: 72px;
      height: 72px;
      border-radius: 4px;
      border: 1px solid #ebeef5;
    }
  }
  .feed-reply-list {
    border: 1px solid #ebeef5;
    border-radius: 4px;
    padding: 12px;
  }
  .feed-reply-item {
    display: flex;
    align-items: flex-start;
    + .feed-reply-item {
      margin-top: 14px;
    }
    &__avatar {
      width: 34px;
      height: 34px;
      border-radius: 50%;
      background: #ecf5ff;
      color: #409eff;
      font-size: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
    }
    &__main {
      flex: 1;
      min-width: 0;
      margin-left: 10px;
    }
    &__head {
      display: flex;
      align-items: baseline;
      margin-bottom: 6px;
      .name {
        font-size: 14px;
        font-weight: 600;
        color: #303133;
      }
      .time {
        margin-left: 10px;
        font-size: 12px;
        color: #909399;
      }
    }
    &__body {
      padding: 10px 12px;
      background: #f5f7fa;
      border-radius: 2px 8px 8px 8px;
    }
    &__content {
      font-size: 13px;
      color: #606266;
      line-height: 1.6;
      white-space: pre-line;
      word-break: break-word;
    }
    &__imgs {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
      margin-top: 8px;
    }
    &__img {
      width: 72px;
      height: 72px;
      border-radius: 4px;
      border: 1px solid #ebeef5;
    }
    &__none {
      color: #c0c4cc;
    }
  }
  .feed-reply-empty {
    text-align: center;
    color: #909399;
    font-size: 13px;
    padding: 30px 0;
  }
}
</style>

<style lang="scss">
.feed-elevator-dropdown .el-select-dropdown__item {
  height: auto;
  line-height: normal;
  padding: 6px 20px;
  white-space: normal;
}
.feed-elevator-dropdown .feed-elevator-option {
  line-height: 1.4;
  .feed-elevator-option__job {
    color: #303133;
  }
  .feed-elevator-option__addr {
    font-size: 12px;
    color: #909399;
  }
}
</style>
